module.exports = "./img/02602d407d7bc824366624e7a799f32f.jpg";